import { useBlockProps, InnerBlocks, RichText } from "@wordpress/block-editor";
import { __ } from "@wordpress/i18n";
import React, { useState } from "react";

interface EditProps {
  attributes: {
    revealLabel: string;
    hideLabel: string;
    anchor?: string;
  };
  setAttributes: (attributes: Record<string, any>) => void;
  isSelected: boolean;
  clientId: string;
}

const Edit: React.FC<EditProps> = ({
  attributes: { revealLabel, hideLabel, anchor },
  setAttributes,
  isSelected,
  clientId,
}) => {
  // State to track if content is visible in the editor
  const [isContentVisible, setIsContentVisible] = useState(false);

  // Toggle content visibility in the editor
  const toggleContent = () => {
    setIsContentVisible(!isContentVisible);
  };

  // Generiere eine eindeutige Content-ID basierend auf dem Anchor oder der clientId
  const contentId = anchor ? anchor : `revealer-content-${clientId.slice(0, 8)}`;

  return (
    <div {...useBlockProps({ className: 'revealer' })}>
      <button
        className="revealer__button"
        onClick={toggleContent}
        aria-expanded={isContentVisible ? 'true' : 'false'}
        aria-controls={contentId}
      >
        {isContentVisible ? (
          <RichText
            tagName="span"
            value={hideLabel}
            onChange={(value) => setAttributes({ hideLabel: value })}
            placeholder={__('Hide label…', 'neodigital')}
            keepPlaceholderOnFocus={true}
          />
        ) : (
          <RichText
            tagName="span"
            value={revealLabel}
            onChange={(value) => setAttributes({ revealLabel: value })}
            placeholder={__('Reveal label…', 'neodigital')}
            keepPlaceholderOnFocus={true}
          />
        )}
      </button>
      <div
        id={contentId}
        className="revealer__content"
        style={{ display: isContentVisible ? 'block' : 'none' }}
      >
        <InnerBlocks />
      </div>
    </div>
  );
};

export default Edit;
